// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const onesignal_api_key = 'bb0ec683-2cb9-4fa7-bcea-c963b0ed9b59';
// export const weglot_api_key = 'wg_8f1df8aa443eb651fba947259e42ffed1'
// export const base_url = 'https://devapi.sicuentame.com/api';
// export const ref_url = 'https://dev.sicuentame.com';
// export const temp_courses = 'https://devapi.sicuentame.com/api';
// export const web_url = 'https://devapp.sicuentame.com';
// // export const web_url = 'https://testapp.sicuentame.com';
// // export const web_url = 'http//localhost:4200';
// export const rh_url = 'https://devadministrador.sicuentame.com/';
// export const admin_url = 'https://devadmin.sicuentame.com/';
// export const pref_logo = 'https://sicuentame-public.s3.amazonaws.com/';
// // export const pref_logo = 'https://sicuentame-dev-public.s3.amazonaws.com/';
// // export const terapia_url = "https://testterapia.sicuentame.com";
// export const terapia_url = "https://devterapia.sicuentame.com";
// // export const terapia_url = "http://localhost:4201";
// export const weglot_request_url = "https://devapp.sicuentame.com";
// // export const weglot_request_url = "https://testapp.sicuentame.com";
// // export const weglot_request_url = 'http//localhost:4200';
// export const sentryDsn = "https://83b44e8eff4478ba48e30dcdf97d70cc@o4504950839050240.ingest.us.sentry.io/4509312838270976"
// export const sentryEnv = "development" 
export const onesignal_api_key = 'c622f4e3-e524-4c17-bcbf-48b379c16476';
export const weglot_api_key = 'wg_8f1df8aa443eb651fba947259e42ffed1'
// export const base_url = 'https://devapi.sicuentame.com';
// export const ref_url = 'https://dev.sicuentame.com';
// export const temp_courses = 'https://devapi.sicuentame.com';


// ENDPOINTS PROD
// export const base_url_v2 = 'https://apiv2.sicuentame.com';
// export const analytics_url = 'https://analytics.sicuentame.com';
// export const media_v2 = 'https://media.sicuentame.com/';
// export const assets_v2 = 'https://assetsv2.sicuentame.com/'
// export const basic_user = 'Cuentame'
// export const basic_password = 's4xYPJ7ksrYA2GZ7veUkeTU2Eju24n42'
// export const ref_url = 'https://sicuentame.com';
// export const web_url = 'https://app.sicuentame.com';
export const cookie_domain = '.sicuentame.com'

// ENDPOINTS DEV
export const basic_user = 'Cuentame'
export const basic_password = 'qnJVws4V6amWvZS6f25DJC7cjmLpQzBz'
export const base_url_v2 = 'https://devapiv2.sicuentame.com';
export const analytics_url = 'https://devanalytics.sicuentame.com';
export const media_v2 = 'https://devmedia.sicuentame.com/';
export const assets_v2 = 'https://devassetsv2.sicuentame.com/'
export const ref_url = 'https://dev.sicuentame.com';
// export const cookie_domain = 'localhost'
export const web_url = 'https://devapp.sicuentame.com';

// export const base_url = '/devapi';
// export const base_url_v2 = 'https://devapiv2.sicuentame.com';
// export const ref_url = 'https://dev.sicuentame.com';
// export const temp_courses = '/devapi';
// export const analytics_url = 'https://devanalytics.sicuentame.com';



export const sentryDsn = "https://83b44e8eff4478ba48e30dcdf97d70cc@o4504950839050240.ingest.us.sentry.io/4509312838270976"
export const sentryEnv = "development" 
export const cookieToken = 'cuentame_token'
export const cookieExpires = 'cuentame_expires_at'

export const token_v2 = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZFVzZXIiOjMsImZpcnN0TmFtZSI6ImZpc3J0TmFtZVRlc3QgMyIsImxhc3ROYW1lIjoibGFzdE5hbWVUZXN0IDMiLCJlbWFpbCI6InVzZXIzQGV4YW1wbGUuY29tIiwidXNlclR5cGVJZCI6MiwiY2xpZW50SWQiOjEsImxhbmd1YWdlSWQiOjEsInBsYXRmb3JtVHlwZSI6ImRlc2t0b3AiLCJ1c2VyQWdlbnQiOiJNb3ppbGxhLzUuMCAoTWFjaW50b3NoOyBJbnRlbCBNYWMgT1MgWCAxMF8xNV83KSBBcHBsZVdlYktpdC81MzcuMzYgKEtIVE1MLCBsaWtlIEdlY2tvKSBDaHJvbWUvMTQzLjAuMC4wIFNhZmFyaS81MzcuMzYiLCJkZXZpY2VUeXBlSWQiOjEsInJlbWVtYmVyRGV2aWNlIjoxLCJ1c2VyUm9sZXMiOlt7ImlkVXNlclJvbGUiOjMsInVzZXJJZCI6Mywicm9sZUlkIjo1fV0sImlhdCI6MTc2ODkzMDY3MSwiZXhwIjoxNzcxNjA5MDcxfQ.1S3Gb6fqFU5TFTyOc6v5628z8CaPAdvLTM-mmJPnAP4'
export const token_v1 = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZF91c2VyIjoiREVNTy0wMDA2OSIsImVtYWlsIjoiZGVtb0BzaWN1ZW50YW1lLmNvbSIsInBob25lIjoiMDUyNDkyMTMyOTg1MyIsImZpcnN0X25hbWUiOiJEZW1vIEFjaGlldmVyMTIzIiwibGFzdF9uYW1lIjoiUGxhdGFmb3JtYTEyMyIsInVzZXJfdHlwZV9pZCI6NSwiY2xpZW50X2lkIjo2LCJyb2xlcyI6WyJhY2hpZXZlciJdLCJ0aW1lem9uZSI6IkFtZXJpY2EvTWV4aWNvX0NpdHkiLCJpYXQiOjE3NzAwOTMyMDgsImV4cCI6MTc3MTMwMjgwOH0.13WxW44HoVJzWpTbgOpZEkFVNFOpwiYxnR_5QmNhGhw';
export const stripePublicKey = "pk_test_51Mmkb4KRTey2Hza77XeTy5wVMfy8hDJ1Fg2nK9fXiuvU7GELsKf8FxkDF7tmPEnwCAEtg3NuT1B9GjolZRoCj3s600DpbUW0Qw"
